import React from 'react'
import { Link } from 'gatsby'

interface ButtonShellProps {
  isAnchor?: boolean
  to: string
  target?: string
  children: any
  className?: string
}

const ButtonShell: React.FC<ButtonShellProps> = ({
  isAnchor = false,
  to,
  target,
  children,
  className = '',
}) =>
  !isAnchor ? (
    <Link to={to} className={className} target={target || '_self'}>
      {children}
    </Link>
  ) : (
    <a href={to} className={className}>
      {children}
    </a>
  )

export default ButtonShell
